import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zh from './locales/zh.json';
import en from './locales/en.json';
import { STORAGE_KEYS } from '@/constants/storage';

// Get saved language preference or use system language
const getSavedLanguage = () => {
  const saved = localStorage.getItem(STORAGE_KEYS.adminLanguage);
  if (saved && (saved === 'zh' || saved === 'en')) {
    return saved;
  }
  // Default to Chinese as per requirement
  return 'zh';
};

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      zh: { translation: zh },
      en: { translation: en },
    },
    lng: getSavedLanguage(),
    fallbackLng: 'zh',
    interpolation: {
      escapeValue: false,
    },
  });

// Listen for language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(STORAGE_KEYS.adminLanguage, lng);
});

export default i18n;
